<template>
  <div>
    <div class="home">
      <!-- <el-dialog v-if="dialogVisible" v-el-drag-dialog title="添加议题" :visible.sync="dialogVisible" width="1400px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose"> -->
        <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center">
            <div style="color:#000;font-size:15px;">议程列表</div>
          <div>
            <el-button-group>
              <el-button v-if="canEdit" size="mini" icon="el-icon-document" @click="addFormFn">新增</el-button>
              <el-button v-if="canEdit" v-text-lbl="'hygl.components.selectMeeting'" size="mini" icon="el-icon-document" @click="clickSelectFn">选择议题</el-button>
              <el-button v-pageBtn-lbl="'export'" icon="el-icon-top" size="mini" @click="exportWformFn">导出</el-button>
            </el-button-group>
          </div>
        </div>
        <el-table v-if="isTableShow" :data="tableData" border row-key="date" class="draggable-table" style="width: 100%" max-height="1000" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="50"></el-table-column>
          <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center">
            <template slot-scope="scope">
              <div>{{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
           <el-table-column v-if="canEdit" prop="orderNo" :label="$tx('hygl.components.order', '排序')" width="70" align="center">
            <template slot-scope="scope">
                    <div style="display: flex; justify-content: center" class="handle">
                        <i style="font-size: 18px" class="el-icon-rank"></i>
                        <span v-text-lbl="'move'">移动</span>
                    </div>
            </template>
          </el-table-column>
          <el-table-column prop="subject" :label="$tx('hygl.components.meetingAgenda', '会议议题')"></el-table-column>
          <el-table-column prop="mainDept" :label="$tx('hygl.components.hostDepartment', '主办部门')" width="140" align="center"></el-table-column>
          <el-table-column prop="reportPersonName" :label="$tx('hygl.components.declarant', '陈述人')" width="120" align="center"></el-table-column>
          <el-table-column prop="startTime" :label="$tx('hygl.components.startTime', '开始时间')" width="180" align="center">
            <template slot-scope="scope">
              <div v-if="canEdit" class="startTime">
                <el-date-picker v-model="scope.row.startTime" style="width:100%;" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :placeholder="$tx('hygl.hyyt.selectStartTime', '选择开始时间')" @change="valueChange($event, scope.row, scope.$index)"></el-date-picker>
              </div>
              <div v-else>
                {{ scope.row.startTime | formatTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="reportTime" :label="$tx('hygl.components.csTime', '陈述时间/分钟')" width="150" align="center"></el-table-column>
          <el-table-column prop="talkTime" :label="$tx('hygl.components.talkTime', '讨论时间/分钟')" width="150" align="center"></el-table-column>
          <el-table-column prop="meetingStatus" :label="$tx('hygl.components.status', '状态')" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.meetingStatus == 0 ? $tx('hygl.components.noMeeting', '未上会') : scope.row.meetingStatus == 1 ? $tx('hygl.components.onMeeting', '已上会') : $tx('hygl.components.waitMeeting', '待上会') }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="" :label="$tx('hygl.components.attach', '附件')" width="70" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.passenger.attachments.length }}</div>
            </template>
          </el-table-column> -->
          <el-table-column v-if="canEdit" prop="caozuo" :label="$tx('pageBtns.operate', '操作')" width="120" align="center">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: space-evenly; color: #1a82e3">
                <span v-pageBtn-lbl="'edit'" @click="editFn(scope.row)">编辑</span>
                <span v-pageBtn-lbl="'del'" @click="delFn(scope.row, scope.$index)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button v-pageBtn-lbl="'down'" icon="el-icon-download" @click="exportWformFn">下 载</el-button>
          <el-button v-pageBtn-lbl="'cancel'" icon="el-icon-close" @click="toClose">取 消</el-button>
          <el-button v-pageBtn-lbl="'sure'" icon="el-icon-check" type="primary" @click="submitHandle">确 认</el-button>
        </span> -->
      <!-- </el-dialog> -->

      <Basicform v-if="show" :title="formTitle" :on-basic-form-before-open="onBasicFormBeforeOpen" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :append-to-body="true" :toolbar-btns="busiformBtns" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-submited="onBasicFormSubmited">
        <template #default="slotProps">
          <busi-form ref="ytk" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
        </template>
      </Basicform>

      <el-dialog :title="$tx('common.operationTip', '操作提示')" :visible.sync="ytmuShow" width="800px">
        <div>
          <el-form>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
              <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                  <tbody>
                    <tr>
                      <td ref="tdlbl_会议目录 " class="el-table__cell tdlbl tdw17" colspan="1">
                        <span class="required">*</span>
                        <span v-field-lbl="'meetShape'" class="field">选择会议目录</span>
                      </td>
                      <td class="el-table__cell tdcont tdw83" colspan="2">
                        <el-select v-model="selectHyml" style="width: 100%" placeholder="请选择">
                          <el-option v-for="item in ytList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                        </el-select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-pageBtn-lbl="'cancel'" @click="ytmuShow = false">取 消</el-button>
          <el-button v-pageBtn-lbl="'sure'" type="primary" @click="selecthyytFn">确 定</el-button>
        </span>
      </el-dialog>

      <YtRecordDialog @selectSubmit="selectSubmit" />
      <RecordDialogForm @submitNoIdHandle="submitNoIdHandle" />
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import YtRecordDialog from './ytRecordDialog.vue'
import RecordDialogForm from './ytRecordDialogForm.vue'
export default {
    components: {
        YtRecordDialog, RecordDialogForm
    },
    filters: {
        formatTime: function (val) {
            if (val) {
                return moment().format('YYYY-MM-DD HH:mm')
            }
            return val
        }
    },
    props: {
        row: {
            type: Object,
            default: () => {}
        },
        canEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            formTitle: '新增议题',
            show: false,
            dialogVisible: false,
            tableData: [],
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                winWidth: 1200,
                delUrl: '/hygl/ytRecord/delete',
                addNewUrl: '/hygl/ytRecord/addNew',
                insertUrl: '/hygl/ytRecord/insert',
                moduleCode: 'budgetKpi',
                winHeight: 600,
                updateUrl: '/hygl/ytRecord/update',
                listDataUrl: '/hygl/ytRecord/listdata',
                getByIdUrl: '/hygl/ytRecord/getById'
            },
            busiformBtns: [],
            isChange: false,
            autoCompute: false, // 是否自动计算
            isTableShow: true,
            xxtxChecked: false,
            selectList: [],
            ytList: [],
            selectHyml: '',
            ytmuShow: false,
            defaultListData: [],
            actionType: 'false' // 会议议程是否有变化，false没有变化，true有变化
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('meetInfoSecond', this.meetInfoSecond)
        this.meetInfoSecond()
    },
    beforeDestroy() {
        this.$bus.off('meetInfoSecond', this.meetInfoSecond)
    },
    mounted() {},
    methods: {
        meetInfoSecond(vo, item) {
            console.log('vo', vo)
            console.log('item===', item)

            this.vo = this.row
            this.selectHyml = this.row.ytId
            this.openFn()
        },
        // 确认
        submitHandle() {
            // this.$http({
            //     method: 'put',
            //     url: '/hygl/hyapYtInfo/batchUpdate',
            //     data: this.tableData
            // }).then((rest) => {
            //     if (rest.code === 'success') {
            //         const name = []
            //         const ids = []
            //         this.ytList.forEach((item) => {
            //             name.push(item.text)
            //             ids.push(item.id)
            //         })
            //         this.vo.ytObject = name.join(',')
            //         this.vo.ytId = ids.join(',')
            //         this.$message.success(rest.message)
            //         this.dialogVisible = false
            //     } else {
            //         this.$message.error(rest.message)
            //     }
            // })
            this.vo.passenger.batchUpdate = this.tableData

            console.log('this.vo.passenger.batchUpdate', this.vo.passenger)

            // this.$message.success(this.$tx('hygl.message.saveSuccess', '保存成功。'))
            this.dialogVisible = false
        },
        submitNoIdHandle(row) {
            console.log('row', row)
            // var obj = {}
            this.actionType = true
            this.vo.passenger.batchUpdate.push(row)
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
        },
        toggleChecked() {
            this.vo.isMessage = (this.vo.isMessage + 1) % 2
        },
        handleSelectionChange(list) {
            this.selectList = list
        },
        exportWformFn() {
            if (!this.tableData.length) {
                this.$alert(this.$tx('hygl.message.noMeetingTitle', '暂无会议议题。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            const headerAlias = {
                subject: '会议议题',
                mainDept: '主办部门',
                reportPersonName: '陈述人',
                startTime: '开始时间',
                reportTime: '陈述时间/分钟',
                talkTime: '讨论时间/分钟',
                status: '状态'
            }

            console.log('JSON.stringify(headerAlias)', JSON.stringify(headerAlias))
            window.open(`/apigw/hygl/ytRecord/dynamicExportData?pageNum=1&pageSize=9999&orderBy=orderNo&urlsearch=meetDirectoryId:${this.vo.ytId}&headerAlias=${encodeURIComponent(JSON.stringify(headerAlias))}&fileName=${encodeURIComponent('会议议题.xlsx')}`)
        },
        clickSelectFn() {
            // this.selectHyml = ''
            this.ytList = []
            console.log('this.vo', this.vo)

            if (this.vo.ytObject && this.vo.ytId) {
                if (this.vo.ytId.indexOf(',') > -1) {
                    const arr = this.vo.ytObject.split(',')
                    const ids = this.vo.ytId.split(',')
                    ids.forEach((item, index) => {
                        this.ytList.push({ text: arr[index], id: item })
                    })
                } else {
                    this.ytList = [{ text: this.vo.ytObject, id: this.vo.ytId }]
                }
            }

            // this.ytmuShow = true
            this.$bus.emit('openMeetYtRecordDialog', this.vo, this.tableData, 'id')
        },
        selecthyytFn() {
            if (!this.selectHyml) return this.$message.warning(this.$tx('hygl.message.selectMeetingMenu', '请选择会议议程。'))
            this.ytmuShow = false
            const ids = []
            this.tableData.forEach((item) => {
                if (item.meetDirectoryYtRecordId) {
                    ids.push(item.meetDirectoryYtRecordId)
                }
            })
            const _this = this
            var el = {
                attrs: {
                    listviewurl: `hygl.ytRecord.list?urlsearch=meetDirectoryYtRecordId!:${ids.join(',')};subjectTypeName:${this.vo.meetingTypeName}`,
                    'dialog-title': _this.$tx('hygl.components.selectMeeting', '选择议题'),
                    'exclude-fields': '',
                    'retain-btns': 'addObject,editObject',
                    multiple: true
                }
            }
            const vnode = {
                context: this,
                data: { model: { expression: '' }}
            }
            this.$bus.emit('openListpageDialog', el, null, vnode)
        },
        selectSubmit(list, callback) {
            const ids = []
            this.actionType = true
            var _this = this
            if (!list.length) {
                callback()
                return
            }
            var defaultIds = []
            this.defaultListData.forEach((item) => {
                defaultIds.push(item.id)
            })
            list.forEach((item) => {
                if (defaultIds.indexOf(item.id) === -1) {
                    ids.push(item.id)
                }
            })

            var obj = { meetDirectoryId: this.selectHyml, ytRecordLists: ids.join(',') }
            console.log('obj', obj)

            list.forEach(item => {
                item.isNew = true
            })
            this.tableData.push(...list)
            _this.tableData = _this.autoComputeTimes(_this.tableData, _this.vo.startTime, 0)
            this.$vnode.context.meetCount = this.tableData.length
            callback()
        },
        onBasicFormBeforeOpen: function($scope, vo, defer) {
            console.log('ytRecord form before open')

            if (vo.isnew) {
                $scope.title = '新增议题'
            } else {
                $scope.title = '会议议题'
            }

            defer.resolve(true)
        },
        ytToInfo(ids) {
            return new Promise((resolve, reject) => {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `/hygl/ytRecord/ytToInfo`,
                    method: 'GET',
                    params: {
                        hyapId: this.vo.id,
                        meetDirectoryId: this.selectHyml,
                        ytIds: ids.join(',')
                    }
                }).then(res => {
                    resolve(res)
                })
            })
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log(attr.listviewurl, 'onSelectListpageRowCompleted')
            const ids = []
            selectedRows.forEach((item) => {
                ids.push(item.id)
            })
            if (ids.length > 0) {
                this.$http({
                    method: 'post',
                    // url: '/hygl/hyapYtInfo/relevanceYtRecord',
                    url: '/hygl/meetDirectoryYtRecord/relevance',
                    params: {
                        // hyapId: this.vo.id,
                        // meetDirectoryId: this.selectHyml,
                        // ytRecordLists: ids.join(),
                        // ifOrder: true
                        meetDirectoryId: this.vo.ytId.split(',')[0],
                        ytRecordIds: ids.join(',')
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.autoCompute = true
                        this.getListData(this.vo)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        /**
         * 表单打开完成，vo为已加载的salary对象，前端页面dom对象已完成初始化、已经呈现，不需要返回值
        */
        onBasicFormOpened: function($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('salary form opened')
            vo.subjectTypeName = this.row.meetingTypeName
        },
        /**
         * 基本表单提交完成，vo为已保存成功的calendar对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited: function($scope, vo) {
            console.log('calendar form submited', $scope)
            if ($scope.moduleInfo.isShengcheng) {
                this.tableData.push(vo)
                vo.passenger.isNew = true
                this.tableData = this.autoComputeTimes(this.tableData, this.row.startTime, 0)
                this.$vnode.context.meetCount = this.tableData.length
            }
        },
        addFormFn() {
            this.moduleInfo.isShengcheng = true
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: this.addFormSaveFn,
                    // btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.show = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, null)
            })
        },
        addFormSaveFn() {
            console.log('this', this)
            const vo = this.$refs.ytk.vo
            vo.passenger.isNew = true
            vo.meetDirectoryYtRecordId = this.vo.ytId
            this.tableData.push(vo)
            //debugger
            this.tableData = this.autoComputeTimes(this.tableData, this.vo.startTime, 0)
            this.show = false
        },
        editFn(row) {
            console.log('row', row)
            // if (!row.id) {
            // this.$bus.emit('openMeetYtRecordDialogForm', row)
            // return
            // }

            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.show = true
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, { id: row.id }, 1, (res) => {
                    this.getListData(this.vo)
                    this.show = false
                    this.autoCompute = true
                })
            })
        },
        delFn(row, index) {
            console.log('index', index)

            var _this = this
            this.$confirm('是否确认删除该议题', this.$tx('common.operationTip', '操作提示'), {
                confirmButtonText: this.$tx('pageBtns.sure', '确 定'),
                cancelButtonText: this.$tx('pageBtns.cancel', '取消'),
                type: 'warning'
            }).then(() => {
                // this.$http({
                //     method: 'delete',
                //     url: '/hygl/hyapYtInfo/delete',
                //     params: {
                //         ids: row.id
                //     }
                // }).then((res) => {
                //     if (res.code === 'success') {
                //         console.log(res)
                //         this.$message.success(res.message)
                //         this.getListData(this.vo)
                //     } else {
                //         this.$message.error(res.message)
                //     }
                // })
                var temp = []
                var ids = []
                if (this.defaultListData.length) {
                    this.defaultListData.forEach((item) => {
                        ids.push(item.id)
                    })
                }
                if (_this.vo.passenger.deleteYtRecord) {
                    temp = _this.vo.passenger.deleteYtRecord.split(',')
                }

                if (ids.indexOf(row.id) > -1) {
                    temp.push(row.id)
                }

                if (temp.length) {
                    _this.vo.passenger.deleteYtRecord = temp.join(',')
                }
                this.actionType = true

                console.log('this.vo', this.vo.passenger)
                this.tableData.splice(index, 1)
                this.tableData = this.autoComputeTimes(this.tableData, this.vo.startTime, 0)
                this.$vnode.context.meetCount = this.tableData.length
                this.$forceUpdate()

                // this.$message.success(this.$tx('hygl.message.delSuccess', '删除成功'))
            })
        },
        async openFn() {
            this.isChange = false
            this.autoCompute = false
            this.tableData = []
            await this.getListData(this.vo, true)
            // setTimeout(() => {
            //     this.$nextTick(() => {
            //         this.register()
            //     })
            // }, 1000)
        },
        register() {
            const _this = this
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
            console.log('tbody', tbody)

            new Sortable(tbody, {
                handle: '.handle', // handle's class
                animation: 150,
                // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                onEnd: ({ newIndex, oldIndex }) => {
                    this.isTableShow = false
                    console.log('newIndex', newIndex)
                    console.log('oldIndex', oldIndex)
                    const targetRow = this.tableData[oldIndex]
                    this.tableData.splice(oldIndex, 1)
                    this.tableData.splice(newIndex, 0, targetRow)
                    _this.autoComputeTimes(this.tableData, _this.vo.startTime, newIndex, oldIndex)
                    console.log('this.tableData', this.tableData)
                    _this.actionType = true

                    this.$nextTick(() => {
                        this.$forceUpdate()
                        this.isTableShow = true
                        this.$nextTick(() => {
                            _this.register()
                        })
                    })
                    this.isChange = true
                }
            })
        },
        getListData(vo, flag = false) {
            var ids = ''
            if (vo.passenger.deleteYtRecord) {
                ids = vo.passenger.deleteYtRecord
            }
            // var urlsearch = ''
            // if (vo.passenger.meetDirectoryIds !== 1) {
            //     urlsearch = `meetDirectoryId:${this.selectHyml}`
            // } else {
            //     urlsearch = `meetDirectoryId:${this.selectHyml};hyapId:${vo.id};id!:${ids}`
            // }

            this.$http({
                method: 'post',
                url: '/hygl/ytRecord/listdata',
                // url: '/hygl/vwHyglMeetDirectoryYtRecord/listdata',
                params: {
                    pageSize: 9999,
                    pageNum: 1,
                    // urlsearch: `meetDirectoryId:${this.selectHyml};hyapId:${vo.id};id!:${ids}`,
                    urlsearch: `meetDirectoryId:${vo.ytId}`,
                    orderBy: 'orderNo asc'
                }
            }).then((res) => {
                if (res.code === 'success') {
                    var list = res.body.pageInfo.list
                    if (vo.passenger.batchUpdate && vo.passenger.batchUpdate.length) {
                        list = vo.passenger.batchUpdate
                    }
                    if (flag) {
                        list.forEach(item => {
                            item.passenger.oldStartTime = item.startTime
                        })
                    }
                    console.log('list', list)
                    this.$vnode.context.meetCount = list.length
                    if (list.length) {
                        var flag1 = list.every(item => item.startTime)
                        if (!flag1) this.autoCompute = true
                    }

                    if (this.autoCompute) {
                        this.tableData = this.autoComputeTimes(list, vo.startTime, 0)
                    } else {
                        this.tableData = list
                    }
                    this.defaultListData = JSON.parse(JSON.stringify(list))
                    this.dialogVisible = true
                    if (this.canEdit) {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                this.register()
                            })
                        }, 500)
                    }
                }
            })
        },
        valueChange(ev, row, index) {
            this.autoCompute = true
            this.actionType = true

            row.passenger.isChange = true

            this.autoComputeTimes(this.tableData, ev, index)
        },
        autoComputeTimes(list, time, startIndex = 0, oldIndex) {
            var defaultDate = new Date(time)
            var previousStartTime = ''
            var newStartTime = ''
            var newArr = list.map((item, index) => {
                // 如果是第一条数据，直接使用默认时间
                if (startIndex <= 0 || oldIndex === 0) {
                    if (index === 0) {
                        item.startTime = moment(new Date(defaultDate)).format('YYYY-MM-DD HH:mm:ss')
                        if (item.isNew) {
                            item.passenger.oldStartTime = item.startTime
                            item.isNew = false
                        }
                        if (item.startTime !== item.passenger.oldStartTime) {
                            item.passenger.isChange = true
                        }
                    } else {
                        // 否则，根据前一条数据的startTime和reportTime计算当前startTime
                        previousStartTime = list[index - 1].startTime
                        newStartTime = new Date(new Date(previousStartTime).getTime() + list[index - 1].reportTime * 60 * 1000 + list[index - 1].talkTime * 60 * 1000)
                        item.startTime = moment(new Date(newStartTime)).format('YYYY-MM-DD HH:mm:ss')
                        if (item.isNew) {
                            item.passenger.oldStartTime = item.startTime
                            item.isNew = false
                        }
                        if (item.startTime !== item.passenger.oldStartTime) {
                            item.passenger.isChange = true
                        }
                    }
                } else {
                    let idx = startIndex
                    if (startIndex > oldIndex) idx = oldIndex
                    if (index >= idx) {
                        if (index === 0) {
                            item.startTime = moment(new Date(defaultDate)).format('YYYY-MM-DD HH:mm:ss')

                            if (item.isNew) {
                                item.passenger.oldStartTime = item.startTime
                                item.isNew = false
                            }
                            if (item.startTime !== item.passenger.oldStartTime) {
                                item.passenger.isChange = true
                            }
                        } else {
                            // 否则，根据前一条数据的startTime和reportTime计算当前startTime
                            previousStartTime = list[index - 1].startTime
                            newStartTime = new Date(new Date(previousStartTime).getTime() + list[index - 1].reportTime * 60 * 1000 + list[index - 1].talkTime * 60 * 1000)
                            item.startTime = moment(new Date(newStartTime)).format('YYYY-MM-DD HH:mm:ss')

                            if (item.isNew) {
                                item.passenger.oldStartTime = item.startTime
                                item.isNew = false
                            }
                            if (item.startTime !== item.passenger.oldStartTime) {
                                item.passenger.isChange = true
                            }
                        }
                    }
                }
                return item
            }, [])
            this.vo.passenger.batchUpdate = newArr

            return newArr
        }
    }
}
</script>

<style scoped lang="scss">
.handle {
    cursor: move;
    display: flex;
    align-content: center;
}
.startTime /deep/ .el-input--prefix .el-input__inner{
    padding: 0 26px !important;
}
</style>
